import styled from "styled-components";

import colors from "../../assets/css/colors";

export const Container = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 64px;
    padding: 0 45px;
    height: 120px;
    background: ${colors.yellowLight} 0% 0% no-repeat padding-box;
    border-radius: 22px;

    @media (max-width: 500px){
        height: 81px;
        padding: 0 10px;
        margin-top: 20px;
        margin-left: -15px;
        margin-right: -15px;
    }
`;

export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
`;

export const ImagesContainer = styled.div`
    display: flex;
    align-items: flex-start;

    @media (max-width: 500px){
        justify-content: center;
    }    
`

export const Title = styled.h1`
    font: normal normal normal 30px Circular Std Book;
    color: ${colors.primary};

    @media (max-width: 500px){
        font: normal normal normal 20px Circular Std Book;
        margin-bottom: 3px;
    }
`;

export const SubTitle = styled.p`
    font: normal normal normal 12px Circular Std Book;
    color: ${colors.tertiary};
    width: 200px;
    margin: 0px;

    @media (max-width: 500px){
        font: normal normal normal 12px Circular Std Book;
        width: 165px;
    }
`;

export const ImageWoman = styled.img`
    width: 100%;

    @media (max-width: 500px){
        width: 45%;
        height: 100%;
        margin-top: 0px !important;
    }
`;

export const ImageNote = styled.img`
    width: 100%;

    @media (max-width: 500px){
        width: 10%;
    }
`;